'use client';

import { memo } from 'react';
import { Alert, Box, CircularProgress } from '@mui/material';
import { useTranslation } from '@/kit/useTranslation';

const ApiStatusMessage = memo(({ loading, error, success, successMsg, loadingMsg, errorMsg }) => {
  const { t } = useTranslation();

  if (loading) {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, my: 2 }}>
        <CircularProgress size={20} />
        <Box sx={{ color: 'text.secondary' }}>{loadingMsg || t('common.loading')}</Box>
      </Box>
    );
  }

  if (error) {
    return (
      <Alert severity="error" sx={{ my: 2 }}>
        {errorMsg || error || t('common.error')}
      </Alert>
    );
  }

  if (success) {
    return (
      <Alert severity="success" sx={{ my: 2 }}>
        {successMsg || t('common.success')}
      </Alert>
    );
  }

  return null;
});

ApiStatusMessage.displayName = 'ApiStatusMessage';

export default ApiStatusMessage;
